module.exports = __webpack_public_path__ + "img/g5.a5564470.png";